import React, {useState, useEffect} from 'react';
import './App.css';
import axios from 'axios';

import { Routes, Route, BrowserRouter as Router, useNavigate } from 'react-router-dom';

// Components
import UponHeader from './components/UponHeader';
import Banniere from './components/Banniere';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

// Pages
import {pages, initializeClubPage} from './pages.js';
import Home from './pages/Home';
import Actus from './pages/Actus';
import Docs from './pages/Docs';
import Performances from './pages/Performances';
import { domain, listClubProad, listClubProam, listClubProbd, listClubProbm,  } from './variables';
import Live from './pages/Live';
import PlayOffDown from './pages/PlayOffDown';
import PlayOffProA from './pages/PlayOffProA';

// Les anciennes URL utilisaient un HashRouter (ex: /pro/#/proad/classement).
// On redirige silencieusement vers l'URL équivalente sans # pour conserver
// les liens déjà partagés/indexés.
function HashRedirect() {
    const navigate = useNavigate();

    useEffect(() => {
        const hash = window.location.hash;
        if (hash.startsWith('#/')) {
            navigate(hash.slice(1), { replace: true });
        } else if (hash === '#') {
            navigate('/', { replace: true });
        }
    }, []);

    return null;
}

function App() {
    const [showPage, setShowPage] = useState(true);
    const [clubLoaded, setClubLoaded] = useState(false);

    // Activer l'affichage des playoff / playdown sur le site.
    const playOffDownVisble = false;
    const playOffProAMVisible = false;

    useEffect(() => {
        if (clubLoaded === false) {
            getClubs()
        }
    }, [])

    const getClubs = async () => {
      const link = domain + '/server/getAllClubs.php';
      await axios.post(
          link, 
          {
              
          }
      ).then(res => {
          const data = res.data;
          parseClubs(data);
          
      })
    }

    const parseClubs = (data) => {
        data.forEach((item) => {
            const sanitize = (value) => {
                if (!value) return '';
                return String(value)
                  .toLowerCase()
                  .normalize('NFD')
                  .replace(/\p{Diacritic}+/gu, '')
                  .replace(/[^a-z0-9]+/g, '-')
                  .replace(/^-+|-+$/g, '');
            }

            const baseSlug = sanitize(item.identifier) || sanitize(item.short) || sanitize(item.libelleClub) || 'club';
            const uniqueSlug = `${baseSlug}-${item.idClub}`;

            const obj = {
                id: item.idClub,
                identifier: item.identifier,
                title: item.libelleClub,
                short: uniqueSlug,
                slug: uniqueSlug,
                salle: item.libelle_salle,
                adresse: item.adresse_salle,
                ville: item.ville_salle,
                cp: item.cp_salle,
                photo: item.photoClub,
                telephone: item.telephoneClub,
                url: item.siteClub,
                photoSalle: item.photoSalle,
            }
            switch (item.championnat) {
              case 'proam':
                  listClubProam.push(obj);
                  break;
              case 'probm':
                  listClubProbm.push(obj);
                  break;
              case 'proad':
                  listClubProad.push(obj);
                  break;
              case 'probd':
                  listClubProbd.push(obj);
                  break;
            }
        })
        initializeClubPage()
        setClubLoaded(true);
    } 

    // Elements of the second navbar
    const underNav = [
        // Page "Présentation" vide pour l'instant -> masquée du menu (route conservée)
        // {id: 1, title: 'PRESENTATION', redirection: '/presentation'},
        {id: 2, title: 'CLUBS', redirection: '/joueurs'},
        {id: 3, title: 'CALENDRIERS/RESULTATS', redirection: '/calendrier'},
        //{id: 4, title: 'PLAYOFFS', redirection: '/playoffs'},
        {id: 5, title: 'CLASSEMENT', redirection: '/classement'},
        {id: 6, title: 'CONTACTS', redirection: '/clubs'},
    ]
    const underNavProAM = [
        // Page "Présentation" vide pour l'instant -> masquée du menu (route conservée)
        // {id: 1, title: 'PRESENTATION', redirection: '/presentation'},
        {id: 2, title: 'CLUBS', redirection: '/joueurs'},
        {id: 3, title: 'CALENDRIERS/RESULTATS', redirection: '/calendrier'},
        //{id: 4, title: 'PLAYOFFS/PLAYDOWNS', redirection: '/playoffs'},
        {id: 5, title: 'CLASSEMENT', redirection: '/classement'},
        {id: 6, title: 'CONTACTS', redirection: '/clubs'},  
    ]
    const underNavProAD = [
        // Page "Présentation" vide pour l'instant -> masquée du menu (route conservée)
        // {id: 1, title: 'PRESENTATION', redirection: '/presentation'},
        {id: 2, title: 'CLUBS', redirection: '/joueurs'},
        {id: 3, title: 'CALENDRIERS/RESULTATS', redirection: '/calendrier'},
        //{id: 4, title: 'PLAYOFFS/PLAYDOWNS', redirection: '/playoffs'},
        {id: 5, title: 'CLASSEMENT', redirection: '/classement'},
        {id: 6, title: 'CONTACTS', redirection: '/clubs'},    
    ]
    const underNavProBM = [
        // Page "Présentation" vide pour l'instant -> masquée du menu (route conservée)
        // {id: 1, title: 'PRESENTATION', redirection: '/presentation'},
        {id: 2, title: 'CLUBS', redirection: '/joueurs'},
        {id: 3, title: 'CALENDRIERS/RESULTATS', redirection: '/calendrier'},
        //{id: 4, title: 'PLAYOFFS/PLAYDOWNS', redirection: '/playoffs'},
        {id: 5, title: 'CLASSEMENT', redirection: '/classement'},
        {id: 6, title: 'CONTACTS', redirection: '/clubs'},
    ]

    // Navbar playoff (empty by default)
    const underNavPlayoffs = []

    // Navbar's elements
    const elements = [];
    if(playOffDownVisble) 
    {
        if(playOffProAMVisible)
        {
            underNavPlayoffs.push({id: 1, title: 'PRO A MESSIEURS', redirection: '/proam'});
        }   
        underNavPlayoffs.push({id: 2, title: 'PRO A DAMES', redirection: '/proad'});    
        underNavPlayoffs.push({id: 3, title: 'PRO B MESSIEURS', redirection: '/probm'}); 
        elements.push({id: 1, title: 'PLAYOFFS/PLAYDOWNS', short: 'playoffs', underNav: underNavPlayoffs, redirection: ''});
        elements.push({id: 2, title: 'PRO A MESSIEURS', short: 'proam', underNav: underNav, redirection: ''});
        elements.push({id: 3, title: 'PRO A DAMES', short: 'proad', underNav: underNavProAD, redirection: ''});
        elements.push({id: 4, title: 'PRO B MESSIEURS', short: 'probm', underNav: underNavProBM, redirection: ''});
        elements.push({id: 5, title: 'PRO B DAMES', short: 'probd', underNav: underNav, redirection: ''});
        elements.push({id: 6, title: 'ACTUALITES', short: 'actus', underNav: null, redirection: '/actus'});
        elements.push({id: 7, title: 'LIVE VIDEO', short: 'live', underNav: null, redirection: '/live'});
    }
    else{
        elements.push({id: 1, title: 'PRO A MESSIEURS', short: 'proam', underNav: underNav, redirection: ''});
        elements.push({id: 2, title: 'PRO A DAMES', short: 'proad', underNav: underNavProAD, redirection: ''});
        elements.push({id: 3, title: 'PRO B MESSIEURS', short: 'probm', underNav: underNavProBM, redirection: ''});
        elements.push({id: 4, title: 'PRO B DAMES', short: 'probd', underNav: underNav, redirection: ''});
        elements.push({id: 5, title: 'ACTUALITES', short: 'actus', underNav: null, redirection: '/actus'});
        elements.push({id: 6, title: 'LIVE VIDEO', short: 'live', underNav: null, redirection: '/live'});
    }

  return (
    <div className="App">
      
        <Router basename="/pro">
          <HashRedirect />
          <div className="content-wrapper">
              {/* UPON HEADER */}
              <UponHeader />
              {/* NAVBAR */}
              <Banniere />
              <Navbar elements={elements} setShowPage={setShowPage}/>
              {
                showPage && clubLoaded &&
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/actus" element={<Actus />} />
                    <Route path="/docs" element={<Docs />} />
                    <Route path="/live" element={<Live />} />
                    <Route path="/performances" element={<Performances />} />
                    <Route path="/proam/playoffs" element={<PlayOffProA championnat="proam" />} />
                    <Route path="/probm/playoffs" element={<PlayOffDown championnat="probm" />} />
                    <Route path="/proad/playoffs" element={<PlayOffDown championnat="proad" />} />
                    <Route path="/playoffs/proam" element={<PlayOffProA championnat="proam" />} />
                    <Route path="/playoffs/probm" element={<PlayOffDown championnat="probm" />} />
                    <Route path="/playoffs/proad" element={<PlayOffDown championnat="proad" />} />
                    {/* Pages division */}
                    {
                        pages.map((item) => {
                            return (
                                item.page.map((page, index) => {
                                    return (
                                        <Route key={index} path={page.path} element={page.component} />
                                    )
                                })
                            )
                        })
                    }
                    {/* <Route path="*" element={<Home />} /> */}
                </Routes>
              }
            </div>
            {/* FOOTER */}
            <Footer />
          </Router>
    </div>
  );
}

export default App;
